// Who sees the migration preparation workbench (TGCLOUD-1890 Phase 2; Tim's rulings,
// 2026-10-07): a genetics service admin, in a migration preparation tenant, with the workbench
// switched on. The server checks all three on every request
// (backend/services/desktopLookupMapping/access.js); this only decides what is shown.
import { CONSTANTS } from 'src/components/Constants';

export const isPreparationTenant = (user) =>
  user?.licence?.state === 'preparation';

export const workbenchSwitchedOn = (systemFeatures) =>
  systemFeatures?.FEATURE_DESKTOP_LOOKUP_MAPPING === true;

export function canUseWorkbench(user, systemFeatures) {
  if (!user || user.block) return false;
  return (
    user.userType === CONSTANTS.userTypes.GENETICS_SERVICE_ADMIN &&
    isPreparationTenant(user) &&
    workbenchSwitchedOn(systemFeatures)
  );
}
